import AdicionarEventoEstagioModal from './AdicionarEventoEstagioModal';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import React, { useEffect, useState } from 'react';
import { DataAmigavel } from '@/shared/utils/datas';
import { Modal, Button, Table } from 'react-bootstrap';
import { ResponseEstagioEventoDto } from '@/api.types';
import { listarEventosEstagio, excluirEventoEstagio } from '@/modules/people/estagio.service';
import { toast } from 'react-toastify';

interface GerenciarEventosEstagioModalProps {
  show: boolean;
  handleHide: () => void;
  idEstagio: number;
}

const getTipoEventoNome = (tipo: number): string => {
  switch (tipo) {
    case 1: return 'Férias';
    case 2: return 'Folga';
    case 3: return 'Abono';
    default: return 'Desconhecido';
  }
};

const GerenciarEventosEstagioModal: React.FC<GerenciarEventosEstagioModalProps> = ({
  show,
  handleHide,
  idEstagio,
}) => {
  const [eventos, setEventos] = useState<ResponseEstagioEventoDto[]>([]);
  const [modalAdicionarShow, setModalAdicionarShow] = useState(false);
  const [eventoEdicao, setEventoEdicao] = useState<ResponseEstagioEventoDto | null>(null);
  const [modalExcluirShow, setModalExcluirShow] = useState(false);
  const [idEventoRemover, setIdEventoRemover] = useState<number | null>(null);

  const carregarEventos = async () => {
    if (idEstagio <= 0) return;

    try {
      const eventosLista = await listarEventosEstagio({
        estagio_id: idEstagio,
        skip: 0,
        take: 100
      });
      setEventos(eventosLista);
    } catch (error: any) {
      console.warn('Erro ao carregar eventos:', error);
      toast.error('Erro ao carregar eventos.');
    }
  };

  useEffect(() => {
    if (show && idEstagio > 0) {
      carregarEventos();
    }
  }, [show, idEstagio]);

  const handleSalvarEvento = async () => {
    await carregarEventos();
    setEventoEdicao(null);
    setModalAdicionarShow(false);
  };

  const abrirModalAdicionar = () => {
    setEventoEdicao(null);
    setModalAdicionarShow(true);
  };

  const abrirModalEditar = (evento: ResponseEstagioEventoDto) => {
    setEventoEdicao(evento);
    setModalAdicionarShow(true);
  };

  const handleExcluirEvento = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (idEventoRemover) {
      try {
        await excluirEventoEstagio(idEventoRemover);
        toast.success('Evento excluído com sucesso.');
        await carregarEventos();
      } catch (error: any) {
        toast.error(error.message || 'Erro ao excluir evento.');
      }
    }
    setModalExcluirShow(false);
    setIdEventoRemover(null);
  };

  return (
    <>
      <Modal show={show} onHide={handleHide} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Gerenciar Eventos de Estágio</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <Button variant="primary" onClick={abrirModalAdicionar}>
              Adicionar Evento
            </Button>
          </div>

          {eventos.length > 0 ? (
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Data Início</th>
                  <th>Data Fim</th>
                  <th>Observação</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {eventos.map((evento) => (
                  <tr key={evento.id}>
                    <td>{getTipoEventoNome(evento.tipo_evento)}</td>
                    <td>{DataAmigavel(evento.data_inicio)}</td>
                    <td>{DataAmigavel(evento.data_fim)}</td>
                    <td>{evento.observacao || '-'}</td>
                    <td>
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className="me-2"
                        onClick={() => abrirModalEditar(evento)}
                      >
                        Editar
                      </Button>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => {
                          setIdEventoRemover(evento.id);
                          setModalExcluirShow(true);
                        }}
                      >
                        Excluir
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p className="text-muted">Nenhum evento registrado para este estágio.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleHide}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

      {modalAdicionarShow && (
        <AdicionarEventoEstagioModal
          show={modalAdicionarShow}
          handleHide={() => {
            setModalAdicionarShow(false);
            setEventoEdicao(null);
          }}
          initialData={eventoEdicao}
          idEstagio={idEstagio}
          onSave={handleSalvarEvento}
        />
      )}

      <ModalExcluir
        show={modalExcluirShow}
        handleExcluir={handleExcluirEvento}
        handleHide={() => {
          setModalExcluirShow(false);
          setIdEventoRemover(null);
        }}
      />
    </>
  );
};

export default GerenciarEventosEstagioModal;

